/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppConfig } from '../../models/app-config';

export interface FindAppConfigByName$Params {
  name: 'logo' | 'urls' | 'messages';
}

export function findAppConfigByName(
  http: HttpClient,
  rootUrl: string,
  params: FindAppConfigByName$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<AppConfig>> {
  const rb = new RequestBuilder(rootUrl, findAppConfigByName.PATH, 'get');
  if (params) {
    rb.path('name', params.name, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AppConfig>;
    })
  );
}

findAppConfigByName.PATH = '/admin/app-configs/{name}';
